import { useState, useMemo, useEffect} from 'react';
import {
  FlyerCard,
  BottomViewFlyers,
  HeaderFixed,
  FlyerboardPagination,
} from '@/components';
import { FlyerType } from '@/config/constants';
import {
  NavBarBackButton,
  FlyerboardHeader,
} from '@/design-system';
import styles from './CommunityFreeFlyerboard.styles'
import { districtVar } from '@/graphql/state';
import { Subscription } from '@/types/subscriptions';
import { useSubscriptionsIds } from '@/hooks';
import { useReactiveVar } from '@apollo/client';
import { AllFlyerFilters, OwningTypeEnum } from '@/graphql/types';

export const CommunityFreeFlyerboard: React.FC = () => {
  const trackId = 'communityFreeFlyerboard';
  const [userDistrict, setUserDistrict] = useState<Subscription[]>([]);
  const district = useReactiveVar(districtVar);
  const schoolIds = useSubscriptionsIds();
  const flyerType = FlyerType.community;

  useEffect(() => {
    if(district) {
      setUserDistrict([
        {
          id: district.districtId,
          name: district.name,
          logo: district.branding.logoUrl,
          type: 'school',
        }
      ])
    }
  }, [district])

  let filters = useMemo((): AllFlyerFilters => ({
    owningType: OwningTypeEnum.organization,
    isCommunityFree: true,
    schoolIds,
  }), [schoolIds]);

  return (
    <div className={styles.container}>
      <HeaderFixed>
        <NavBarBackButton trackId={trackId}>
          Free
        </NavBarBackButton>
        <FlyerboardHeader
          subscriptions={userDistrict}
          type={flyerType}
          selectedAudienceId={district?.districtId.toString() ?? ''}
        />
      </HeaderFixed>
      <FlyerboardPagination
        trackId={trackId}
        flyerType={flyerType}
        flyerboardFilters={filters}
      />
      <BottomViewFlyers
        variant={FlyerType.community}
      />
    </div>
  )
};
